// extracted by mini-css-extract-plugin
export var actionButton = "_e6-0";
export var attachmentLine = "_e6-1";
export var fileInput = "_e6-2";
export var fileUploadWrapper = "_e6-4";
export var footer = "_e6-3";
export var modalContent = "_e6-5";
export var paperclip = "_e6-6";
export var quillEditor = "_e6-7";